import LogicalErrorsDialog  from './LogicalErrorsDialog';

export default LogicalErrorsDialog ;